import uuid from 'uuid';

export default function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      const id = uuid.v4();
      const label = element.children('label');
      const textarea = element.children('textarea');
      const input = element.children('input').length
        ? element.children('input')
        : element.children('div').length ? element.children('div').children('input') : [];

      if (label.length) {
        label.removeAttr('for');
        label.attr('for', id);
      }

      if (textarea.length) {
        textarea.removeAttr('id');
        textarea.attr('id', id);
        textarea.removeAttr('name');
        textarea.attr('name', id);
      }

      if (input.length) {
        input.removeAttr('id');
        input.attr('id', id);
        if (input[0].type !== 'radio') {
          input.removeAttr('name');
          input.attr('name', id);
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/uniqueId/index.js